module.exports = __webpack_public_path__ + "static/img/0.bf1bb8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eg/0.png
// module id = 120
// module chunks = 2